import { render } from "./workflow.vue?vue&type=template&id=cad81078"
import script from "./workflow.vue?vue&type=script&lang=js"
export * from "./workflow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__